<template>
    <div>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Beschreibung"
                property="feeText"
                required
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Rechnungsdatum"
                property="dateReceipt"
                required
                type="date"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Bemerkung"
                property="paymentComment"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Bruttobetrag"
                property="amount"
                required
                type="currency"
                @input="updateAmountNet"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Teil- / Gutschrift (brutto)"
                property="amountAdjustmentGross"
                type="currency"/>
        </b-row>
        <b-row>
            <b-col class="ml-auto" cols="6">
                <b-row>
                    <csp-desktop-info-card-element
                        class="col-6"
                        :form-context="formContext"
                        label="Nettobetrag"
                        property="amountNet"
                        type="currency"/>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

export default {
    name: 'FeeEditBasedata',
    mixins: [FormDataMixin],
    methods: {
        updateAmountNet(amount) {
            this.formContext.form.data.amountNet =
                Math.round(amount / this.formContext.complexFields.amountNet.contextData.vatRateFactor);
        },
    },
}
</script>
